import React from "react";
import { Radio, Segment } from "semantic-ui-react";
import parse from "html-react-parser";

interface Props {
  questionHeading: string;
  invalid: boolean;
  value: number | null;
  choices: { englishText: string; translatedText: string; value: number }[];
  onValueChange: (value: number, text: string) => void;
}

export default function McqQuestionControl({
  questionHeading,
  onValueChange,
  choices,
  invalid,
  value,
}: Props) {
  const changeValue = (newValue: number, text: string) => {
    onValueChange(newValue, text);
  };
  return (
    <>
      <div className={invalid ? "negative-message" : "question-wrapper"}>
        <label className="statement">{parse(questionHeading)}</label>
        <Segment className="survey-answers feedradiocheck">
          {choices &&
            choices.length > 0 &&
            choices.map((choice, index) => (
              <Radio
                key={index}
                checked={value === choice.value}
                onChange={() => {
                  changeValue(choice.value, choice.englishText);
                }}
                label={choice.translatedText}
              />
            ))}
        </Segment>
      </div>
    </>
  );
}
